const API_URLS = {
  localization: {
    getLocalization: "/v1/meta/static/desktopLanguages",
  },
  auth: {
    autoLogin: "/v2/saka/authsession/autologin",
    login: "/v2/saka/authsession/login",
    register: "/v2/saka/authsession/register",
    logout: "/v2/saka/authsession/logout",
    changeCurrencyAndLanguage: "/v2/saka/authsession/changeCurrencyAndCulture",

    getFlightPassengers: "/v1/accounts/user/flightPassengers",
  },
  favorite: {
    addFlight: "/v1/meta/favorite/AddFlight",
    getFavorites: "/v1/meta/favorite/GetAll",
    removeFlight: "/v1/meta/favorite/Remove",
  },
  priceAlarm: {
    createPriceAlarm: "v2/saka/pricealarm/createpricealarm",
    getPriceAlarms: "v2/saka/pricealarm/getpricealarms",
    deletePriceAlarm: "v2/saka/pricealarm/deletepricealarm",
  },
  basket: {
    getMyTrips: "v2/saka/basket/getmytrips",
    generateBasketHashCode: "v2/saka/basket/generatebaskethashcode",
    getBasketByHashCode: "v2/saka/basket/getbasketbyhashcode",
  },
  sections: {
    // Ana sayfa API'leri
    getFaq: "/v1/meta/flighthome/Faq",
    getBlogs: "/v1/meta/flighthome/blog",
    getCampaigns: "/v1/flight/AllCampaign/GetAllCampaigns",
    getPopularAirlines: "/v1/analytics/meta/popularairlines",

    // Flight API'leri
    getCheapestFlights: "/v1/flight/cheapestflight/getcheapflightpopularroutes",
    getPopularAirports: "/v1/analytics/meta/popularairports",
    getPopularRoutes: "/v1/analytics/meta/popularroutes",

    // Landing page API'leri
    getRouteCheapestRoutes: "/v1/meta/FlightRouteLandingPage/getcheapestroutes",
    getCheapestAlternativeRoutes:
      "/v1/meta/FlightRouteLandingPage/GetCheapestAlternativeRoutes",
    getPopularAirlinesLanding:
      "/v1/meta/FlightRouteLandingPage/getpopularairlines",
    getFlightRouteDynamicQuestion:
      "/v1/meta/FlightRouteLandingPage/routedynamicquestionanswer",
    getFlightRouteDynamicText:
      "/v1/meta/FlightRouteLandingPage/routedynamictext",
    getCalendarOneWay: "/v1/analytics/calendar/oneway",
    getCityDynamicText: "/v1/meta/FlightCityLandingPage/RouteDynamicText",
    getCityDynamicQuestion:
      "/v1/meta/FlightCityLandingPage/RouteDynamicQuestionAnswer",
    getGetCityNeighbors: "/v1/meta/FlightCityLandingPage/GetCityNeighbors",
    getCityGetCheapestRoutes:
      "/v1/meta/FlightCityLandingPage/GetCheapestRoutes",
    getAirlineDynamicText:
      "/v1/meta/FlightAirlineLandingPage/AirlineDynamicText",
    getAirlineGetPopularDestinations:
      "/v1/meta/FlightAirlineLandingPage/GetPopularDestinations",
    getAirlineGetOtherAirlines:
      "/v1/meta/FlightAirlineLandingPage/GetOtherAirlines",
    getAirlineDynamicQuestionAnswer:
      "/v1/meta/FlightAirlineLandingPage/AirlineDynamicQuestionAnswer",
    getAirlineGetPopularRoutes:
      "/v1/meta/FlightAirlineLandingPage/GetPopularRoutes",
    getAirlineGetInformation:
      "/v1/meta/FlightAirlineLandingPage/GetInformation",
    getAirlineGetAirlinePromotions:
      "/v1/meta/FlightAirlineLandingPage/GetPromotions",
    getCityBlogs: "/v1/meta/FlightCityLandingPage/GetBlog",
    getContinentCheapestRoutes:
      "/v1/meta/FlightContinentLandingPage/PopularCheapestFlights",
    getContinentPopularCountries:
      "/v1/meta/FlightContinentLandingPage/PopularCountries",
    getContinentPopularCities:
      "/v1/meta/FlightContinentLandingPage/PopularCities",
    getContinentPopularAirlines:
      "/v1/meta/FlightContinentLandingPage/PopularAirlines",
    getContinentBlogs: "/v1/meta/FlightContinentLandingPage/GetBlog",
    getCountryCheapestRoutes:
      "/v1/meta/FlightCountryLandingPage/GetCheapestRoutes",
    getCountryPopularCities:
      "/v1/meta/FlightCountryLandingPage/GetPopularCities",
    getCountriesPopularAirlines:
      "/v1/meta/FlightCountryLandingPage/GetPopularAirlines",
    getCountryNeighbors:
      "/v1/meta/FlightCountryLandingPage/GetNeighborCountries",
    getCountryDynamicContent:
      "/v1/meta/FlightCountryLandingPage/DynamicContent",
    getCountryBlogs: "/v1/meta/FlightCountryLandingPage/GetBlog",
    getCountryInformation: "/v1/meta/FlightCountryLandingPage/GetInformation",
    getAirportCheapestRoutes:
      "/v1/meta/FlightAirportLandingPage/GetCheapestRoutes",
    getAirportPopularAirlines:
      "v1/meta/FlightAirportLandingPage/GetPopularAirlines",
    getAirportDynamicContent:
      "/v1/meta/FlightAirportLandingPage/DynamicContent",
    getAirportPopularCarCompanies:
      "/v1/meta/FlightAirportLandingPage/GetPopularCarCompanies",
    getAirportsBlogs: "/v1/meta/FlightAirportLandingPage/GetBlog",
    getInternationalFlightDynamicContent:
      "/v1/meta/FlightInternationalFlightsLandingPage/DynamicContent",
    getDomesticFlightDynamicContent:
      "v1/meta/FlightDomesticFlightsLandingPage/DynamicContent",
    getAllAirlinesDynamicContent:
      "/v1/meta/FlightAllAirlineLandingPage/DynamicContent",
    getAllAirportsDynamicContent:
      "/v1/meta/FlightAllAirportsLandingPage/DynamicContent",
    getCompanyDynamicContent:
      "/v1/meta/FlightCompanyLandingPage/DynamicContent",
    getCommercialPageConfig: "/v1/meta/flightcommerciallandingpage/getConfig",
    getCommercialInformation:
      "/v1/meta/flightcommerciallandingpage/getInformation",
    getCommercialCheapestRoutes:
      "/v1/meta/flightcommerciallandingpage/getCheapestRoutes",
    getCommercialDynamicContent:
      "/v1/meta/flightcommerciallandingpage/dynamicContent",
    getCommercialCampaigns: "/v1/meta/flightcommerciallandingpage/GetCampaigns",
    getCommercialFeaturedHotels:
      "/v1/meta/flightcommerciallandingpage/GetFeaturedHotels",
    // Diğer
    decidePageType: "/v1/meta/flight/DecidePageType",
  },
  flight: {
    getOffersByBasketId: "/v2/saka/basket/GetOffersByHashCode",
    insertRefundOffers: "/v2/saka/basket/InsertRefundOffers",
    insertReissueOffers: "/v1/flight/offer/InsertReissueOffers",
    updateOfferStatus: "/v1/flight/offer/UpdateOfferStatus",
    makeReissueInit3d: "/v1/flight/offer/MakeReissueInit3d",
    makePointPayment: "/v1/flight/offer/MakePointPayment",
    reissueOfferCheckout: "/v1/flight/offer/ReissueOfferCheckout",
    getFlightSuggestions: "/v1/flight/suggestions",
    getFlightSuggestionsByQuery: "/v1/meta/autocomplete/flight",
    getPopularCities: "/v1/meta/flighthome/PopularCities",
    getNearestAirports: "/v1/meta/flighthome/NeighborAirports",
    getCheapestFlightsMonthly: "/v1/analytics/calendar/OneWayMonthly",
    getCheapestFlightsTo: "/v1/analytics/cheapest/flights_to",
    getOneWayCalendarPrices: "/v1/analytics/calendar/oneway",
    getRoundTripCalendarPrices: "/v1/analytics/calendar/roundtrip",
    getFlightDefaultOrigin: "/v1/meta/flighthome/GetOrigin",
    parseSearchQuery: "/v1/meta/flight/ParseSearchQuery",
    getCheckinUrl: "/v2/flight/Checkin/Url",
  },
  flightResults: {
    getFlightListingResults: "v2/flight/ticketing/Search",
    getNextDayCheapFlightMessage:
      "v1/flight/PriceMessage/GetNextDayCheapFlightMessage",
    getDontMissCheapFlightMessage:
      "/v1/flight/PriceMessage/GetDontMissCheapFlightMessage",
    allocateFlight: "/v2/flight/ticketing/Allocate",
    getCheapestBus: "/v1/meta/FlightRouteLandingPage/GetCheapestBusTrip",
    getActiveCampaigns: "/v2/saka/campaigns/ActiveCampaigns",
  },
  flightAllocate: {
    getActiveBasket: "/v2/saka/basket/getBasket",
    reservationOrderCreate: "/v2/flight/ticketing/Reserve",
    getBasketForReservationLink: "/v2/saka/basket/GetBasketForReservationLink",
  },
  static: {
    getStaticData: "/v1/meta/static/Content",
    getHomePrivileges: "/api/v1/analytics/static/HomePrivileges",
    getHomePopularLocations: "/api/v1/analytics/static/HomePopularLocations",
    getHomePopularRoutes: "/api/v1/analytics/static/HomePopularRoutes",
    getHomeCityGuide: "/api/v1/analytics/static/HomeCityGuide",
    getHomeLatestDeals: "/api/v1/analytics/static/HomeLatestDeals",
  },
  payment: {
    getPaymentInfo: "/v2/saka/basket/getBasket",
    getReissuePaymentInfo: "/v2/saka/basket/getReissueBasket",
    applyCoponCode: "/v2/saka/campaigns/applyDiscountWithCampaignCode",
    applyCoponCodeExceptFlight:
      "/v1/campaign/allCampaign/applyDiscountWithCampaignCode",
    removeCoponCode: "/v2/saka/campaigns/removeDiscountWithCampaignCode",
    removeCoponCodeExceptFlight:
      "/v1/campaign/allCampaign/removeDiscountWithCampaignCode",
    getSavedCards: "/v1/common/payment/getSavedCardsInfo",
    getInstalments: "/v1/common/payment/getInstalments",
    getAllInstalments: "/v1/common/payment/getAllInstalments",
    applyTurnaPoints: "/v1/common/payment/applyTurnaPoint",
    init3dPaymentWithNewCard: "/v2/saka/payment/init3d",
    init3dPaymentWithStoredCard: "/v2/saka/payment/initThreeDStoredCardPayment",
    payWithTurnaPoints: "/v2/saka/payment/pointPayment",
    getStoredCards: "/v1/accounts/user/getUserUserCreditCards",
    completePayment: "/v2/saka/basket/checkout",
    getUsabledCampaigns: "/v2/saka/campaigns/getApplicableCampaigns",
    getBinDetails: "/v2/saka/payment/getBinDetails",
    getBinDetailsByCardNumber: "/v2/saka/payment/getBinDetailsByCardNumber",
    getPaymentConfiguration: "/v2/saka/configuration/get",
    carDeliveryPayment: "/v2/saka/payment/onDeliveryPayment",
    saveCreditCardFromSession: "/v2/saka/creditcard/SaveCreditCardFromSession",
  },
  common: {
    linkVivolloSession: "/v2/saka/vivollo/linkSession",
    getBlogPosts: "/v2/saka/blog/getBlogPosts",
    getLocalizedCountries: "/v1/meta/flight/LocalizedCountries",
    getCountryCodes: "/v1/meta/base/countries",
    getCountries: "/v1/meta/base/countries",
    getCities: "/v1/meta/integration/getIntegrationCities",
    getCountriesNew: "/v1/meta/base/LocalizedCountries",
    getTaxOffices: "/v1/meta/integration/getIntegrationTaxOffices",
    getCampaignDataByCampaignId: "/v2/saka/campaigns/getCampaignDetail",
    checkRedirect: "/v2/saka/routing/checkRedirect",
    getRedirectUrls: "/v2/saka/routing/redirectUrls",
    createTicketPdf: "/v2/saka/basket/createTicketPdf",
    getCurrencies: "/v1/meta/base/currencies",
    getLanguages: "/v1/meta/base/cultures",
    getContactSubjects: "/v2/saka/contact/GetContactSubjects",
    submitContactForm: "/v2/saka/contact/submitContactForm",
    getPersonalOffersCampaigns: "/v2/saka/campaigns/PersonalOffersCampaigns",
    submitApiPartnershipForm: "v2/saka/contact/submitapipartnershipform",
    emailSubscribe: "/v2/saka/Newsletter/InsertNewsLetter",
    getInvitationLink: "/v2/saka/profile/getinvitationlink",
    getLocalizationByKey: "/v2/saka/localization/getLocalization",
    getQuickHelpQuestions: "/v1/meta/faq/GetQuickHelpQuestions",
  },
  esim: {
    product: {
      getProviders: "/v1/esim/product/getproviders",
      getProducts: "/v1/esim/product/getproducts",
      addToBasket: "/v1/esim/product/addtobasket",
      removeFromBasket: "/v1/esim/product/removefrombasket",
    },
  },

  /**
   * Bus API'leri
   */
  bus: {
    auth: {
      getPassengers: "/v1/accounts/user/flightpassengers",
    },
    search: {
      autocomplete: "/v1/meta/autocomplete/busv2",
    },
    basic: {
      decidePageType: "/v1/sbus/basic/decidepagetype",
      getAllCampaigns: "/v1/sbus/basic/getallcampaigns",
      getAllPrivileges: "/v1/sbus/basic/GetAllPrivileges",
      getBlog: "/v2/saka/blog/getBlogPosts",
      getSss: "/v1/sbus/basic/sss",
      getListCampaigns: "/v1/sbus/basic/getturnalistcampaigns",
    },
    sales: {
      getOriginAndDestination: "/v1/bus/sales/GetOriginAndDestination",
      searchv2: "/v1/bus/sales/searchv2",
      busTripDetailsV2: "/v1/bus/sales/bustripdetailsV2",
      busTripDetailsSmarttrip: "/v1/bus/sales/bustripdetailssmarttrip",
      allocate: "/v1/bus/sales/allocatev2",
      calculateSeatFares: "/v1/bus/sales/calculateseatfares",
      makePrebook: "/v1/bus/sales/makeprebook",
      getBasket: "/v2/saka/basket/getBasket",
      cancelBusBook: "/v1/bus/sales/CancelBusBookV2",
    },
    home: {
      getCheapestRoutes: "/v1/sbus/home/getcheapestroutes",
      getLastMinuteSales: "/v1/sbus/home/getlastminutesales",
      getPopularBusCompanies: "/v1/sbus/home/getpopularbuscompanies",
      getPopularRoutes: "/v1/sbus/home/popularroutes",
      getWhyTurna: "/v1/sbus/home/whyturna",
      getPopularDestinations: "/v1/sbus/home/PopularDestinations",
      getPopularRouteCitiesAndCenters:
        "/v1/sbus/home/popularroutecitiesandcenters",
    },
    route: {
      getCheapestTrips: "/v1/sbus/route/cheapesttrips",
      getRouteInfo: "/v1/sbus/route/info",
      getPopularCompanies: "/v1/sbus/route/popularcompanies",
      getRouteAbout: "/v1/sbus/route/about",
      getRouteSss: "/v1/sbus/route/sss",
      getRouteBusStations: "/v1/sbus/route/busstations",
      getOtherTravelOptions: "/v1/sbus/route/othertraveloptions",
    },
    city: {
      getCheapestRoutes: "/v1/sbus/city/cheapestroutes",
      getCityInfo: "/v1/sbus/city/info",
      getPopularCompanies: "/v1/sbus/city/popularcompanies",
      getPopulars: "/v1/sbus/city/populars",
      getCityAbout: "/v1/sbus/city/about",
      getCitySss: "/v1/sbus/city/sss",
      getSearchPopulars: "/v1/sbus/city/searchpopulars",
      getBusStations: "/v1/sbus/city/busstations",
      getAverageTravelDurations: "/v1/sbus/city/avaragetraveldurations",
      getOtherTravelOptions: "/v1/sbus/city/othertraveloptions",
    },
    company: {
      getCompanyList: "/v1/sbus/company/list",
      getCompanyAbout: "/v1/sbus/company/about",
      getCompanyListAbout: "/v1/sbus/company/listabout",
      getCompanyTag: "/v1/sbus/company/tag",
      getCompanyFaq: "/v1/sbus/company/sss",
      getCompanyPopularRoutes: "/v1/sbus/company/popularroutes",
      getCompanyPopularRouteCitiesAndCenters:
        "/v1/sbus/company/popularroutecitiesandcenters",
      getCompanyServices: "/v1/sbus/company/services",
    },
    station: {
      getStationList: "/v1/sbus/busstation/list",
      getStationListAbout: "/v1/sbus/busstation/listabout",
      getStationTag: "/v1/sbus/busstation/tag",
      getStationPopularRoutes: "/v1/sbus/busstation/popularroutes",
      getStationAbout: "/v1/sbus/busstation/about",
      getStationCompanies: "/v1/sbus/busstation/companies",
      getStationHowToReach: "/v1/sbus/busstation/howtoreach",
      getStationCoordinates: "/v1/sbus/busstation/coordinates",
      getNearbyStations: "/v1/sbus/busstation/nearbystations",
      getOtherOpportunities: "/v1/sbus/busstation/getotheropportunities",
      getStationFaq: "/v1/sbus/busstation/sss",
      getStationEmbedMap: "/v1/sbus/busstation/embedmap",
    },
  },
  ferry: {
    auth: {
      getPassengers: "/v1/sferry/sakaFerryUser/passengers",
    },
    sales: {
      getBasket: "/v2/saka/basket/getBasket",
      makePrebook: "/v1/sferry/sakaFerryBooking/reserve",
      getCompanyImportantNotes: "/v1/sferry/companies/importantNotes",
    },
    search: {
      originSearch: "/v1/sferry/search/origins",
      destinationSearch: "/v1/sferry/search/destinations",
      popularOrigins: "/v1/sferry/search/popularOrigins",
      getVehicles: "/v1/sferry/search/vehicles",
      searchResults: "/v1/sferry/search/trips",
      getOriginAndDestination: "/v1/sferry/search/initialData",
      allocate: "/v1/sferry/sakaFerryBooking/allocate",
      allocateCouponSale: "/v1/sferry/sakaFerryBooking/allocateCoupon",
      reserve: "/v1/sferry/sakaFerryBooking/reserve",
    },
    basic: {
      decidePageType: "/v1/sferry/page/type",
      getAllCampaigns: "/v1/sferry/campaigns/all",
      getAllPrivileges: "/v1/sferry/contents/privileges",
      getBlog: "/v1/sferry/contents/blogPosts",
      getSss: "/v1/sferry/contents/faqs",
      getListCampaigns: "/v1/sferry/campaigns/ferryApplicableCampaigns",
    },
    home: {
      getCheapestRoutes: "/v1/sferry/routes/popularsHomePage",
      getLastMinuteSales: "/v1/sbus/home/getlastminutesales",
      getPopularFerryCompanies: "/v1/sferry/companies/populars",
      getPopularLocations: "/v1/sferry/locations/populars",
      getWhyTurna: "/v1/sferry/contents/why",
      getPopularDestinations: "/v1/sbus/home/PopularDestinations",
    },
    popular: {
      getPopularDomesticFerries: "/v1/sferry/routes/popularsDomestic",
      getPopularGreeceIslands: "/v1/sferry/routes/popularsGreeceIslands",
      getPopularCyprus: "/v1/sferry/routes/popularsCyprus",
      getPopularInternational: "/v1/sferry/routes/popularsInternational",
      getPopularLocations: "/v1/sferry/locations/populars",
      getPopularIslands: "/v1/sferry/locations/popularIslands",
      getPopularFerryCompaniesForLocation:
        "/v1/sferry/companies/popularCompaniesByDestination",
    },
    route: {
      getCheapestTrips: "/v1/sbus/route/cheapesttrips",
      getRouteInfo: "/v1/sbus/route/info",
      getPopularCompanies: "/v1/sferry/companies/popularCompaniesForRoute",
      getRouteAbout: "/v1/sbus/route/about",
      getCheapestFerriesForCompany:
        "/v1/sferry/routes/cheapestFerriesForCompany",
      getCheapestFerriesBetween: "/v1/sferry/routes/cheapestFerriesBetween",
      getCheapestFerriesFromOrigin: "/v1/sferry/routes/fromOrigin",
      getCheapestFerriesFromOriginForTicketCards:
        "/v1/sferry/routes/cheapestFerriesFromOrigin",
      getCheapestFerriesToDestination: "/v1/sferry/routes/toDestination",
      getCheapestFerriesFromPort: "/v1/sferry/routes/fromPort",
      getCheapestFerriesFromPortForTicketCards:
        "/v1/sferry/routes/cheapestFerriesFromPort",
      getCheapestFerriesToPort: "/v1/sferry/routes/toPort",
      getPortInfo: "/v1/sferry/ports/info",
      getClosestPorts: "/v1/sferry/ports/closetsPorts",
      getPopularCompaniesByPort: "/v1/sferry/companies/popularCompaniesByPort",
      getPortQAContent: "/v1/sferry/ports/qaContent",
      getRouteTravelHighlights: "/v1/sferry/routes/triviaContentForRoute",
      getDestinationTravelHighlights:
        "/v1/sferry/routes/triviaContentForDestination",
      getRouteContent: "/v1/sferry/routes/routeContent",
      getRouteQAContent: "/v1/sferry/routes/routeQAContent",
      getRoutesByCompany: "/v1/sferry/routes/routesByCompany",
      getCheapestGreeceIslands: "/v1/sferry/routes/cheapestGreeceIslands",
      getGreeceIslandsContent: "/v1/sferry/routes/greeceIslandsContent",
      getPopularsGreeceIslands: "/v1/sferry/routes/popularsGreeceIslands",
      getCheapestCyprusFerries: "/v1/sferry/routes/cheapestCyprusFerries",
      getCyprusContent: "/v1/sferry/routes/cyprusContent",
      getPopularsCyprus: "/v1/sferry/routes/popularsCyprus",
    },
    location: {
      getLocationContent: "/v1/sferry/locations/locationContent",
      getLocationQAContent: "/v1/sferry/locations/locationQAContent",
      getLocationsByCompanyId: "/v1/sferry/locations/byCompanyId",
    },
    company: {
      getCompanyList: "/v1/sferry/companies/all",
      getCompanyListAbout: "/v1/sbus/company/listabout",
      getCompanyContent: "/v1/sferry/companies/getCompanyContent",
      getCompanyQAContent: "/v1/sferry/companies/getCompanyQAContent",
      getPopularCompaniesGreeceIslands:
        "/v1/sferry/companies/popularCompaniesGreeceIslands",
      getPopularCompaniesCyprus: "/v1/sferry/companies/popularCompaniesCyprus",
    },
    city: {
      getCheapestRoutes: "/v1/sbus/city/cheapestroutes",
      getCityInfo: "/v1/sbus/city/info",
      getPopularCompanies: "/v1/sbus/city/popularcompanies",
      getPopulars: "/v1/sbus/city/populars",
      getCityAbout: "/v1/sbus/city/about",
      getCitySss: "/v1/sbus/city/sss",
    },
  },
  hotel: {
    abroad: {
      getPopularHotelLocationsTitle: "/v1/hotel/content/static",
      getPopularInternationalHotels: "/v1/hotel/content/static",
      getPopularHotelLocations: "/v1/hotel/content/static",
      getPopularCountryHotels: "/v1/hotel/content/popularhotels",
    },
    auth: {
      getGuests: "/v1/accounts/user/hotelguests",
    },
    search: {
      autocomplete: "/v1/meta/autocomplete/hotelweb",
      getHotels: "/v1/hotel/reservation/search",
      addFavorite: "/v1/meta/favorite/addhotel",
      removeFavorite: "/v1/meta/favorite/remove",
      getPopularLocations: "/v1/hotel/content/popularsearches",
      GoogleMaps: "/v1/hotel/reservation/mapsearch",
    },
    detail: {
      getHotelDetailOrLanding: "/v1/hotel/reservation/searchandallocate",
      getOtherProducts: "/v1/hotel/content/otherproducts",
    },
    reservation: {
      getReservation: "/v1/hotel/reservation/quote",
      getBasket: "/v2/saka/basket/getBasket",
      getReserve: "/v1/hotel/reservation/reserve",
      /** Otel rezervasyon iptal – gerçek endpoint ile güncellenecek */
      cancelHotelReservation: "/v1/hotel/reservation/cancelbook",
    },
    basic: {
      getAllCampaigns: "/v1/hotel/hotelcampaign/campaigns",
      getAllPrivileges: "/v1/hotel/content/static",
      getBlog: "/v2/saka/blog/getBlogPosts",
      getSss: "/v1/hotel/content/faq",
      getContentBySlug: "/v1/hotel/content/slug",
      getMainText: "/v1/hotel/content/main",
      getBreadcrumb: "/v1/hotel/content/breadcrumb",
    },
    home: {
      getPopularHolidayAreas: "/v1/hotel/content/static",
      getPopularHotels: "/v1/hotel/content/static",
      getPopularDestinations: "/v1/hotel/content/static",
      getPopularInternationalHotels: "/v1/hotel/content/static",
      getPopularInternationalDestinations: "/v1/hotel/content/static",
      getPopularCountries: "/v1/hotel/content/static",
      getHotelThemes: "/v1/hotel/content/static",
    },
    landing: {
      getHotelsList: "/v1/hotel/landing/hotels",
      getContentBySlug: "/v1/hotel/landing/content",
      getOtherProducts: "/v1/hotel/content/otherproducts",
    },
  },
  car: {
    search: {
      autocomplete: "/v1/meta/autocomplete/car",
      getPopularLocations: "/v1/meta/autocomplete/popularCarLocations",
      getCarList: "/v1/car/rental/SearchODAvailable",
      getSearchQueryDetails: "/v1/scar/search/QueryDetails",
    },
    basic: {
      getAllCampaigns: "/v1/scar/home/GetAllCampaigns",
      getBlog: "/v2/saka/blog/getBlogPosts",
      getAllPrivileges: "/v1/scar/home/Privileges",
      getSss: "/v1/scar/home/FAQ",
    },
    home: {
      getPopularLocations: "/v1/scar/home/PopularLocations",
      getWhyTurna: "/v1/scar/home/WhyTurna",
      getPopularCars: "/v1/scar/home/PopularVehicles",
      getPopularCompanies: "/v1/scar/home/PopularCompanies",
      getPopularRentalLocations: "/v1/scar/home/PopularRentalLocations",
    },
    sales: {
      allocateCar: "v1/car/rental/allocate",
      prebook: "v1/car/rental/prebook",
      getBasket: "/v1/saka/basket/GetBasket",
    },
    findeks: {
      getPhoneList: "/v1/car/findex/getPhoneList",
      generateReport: "/v1/car/findex/generateReport",
      confirmFindeksPIN: "/v1/car/findex/confirmPIN",
      renewFindeksPIN: "/v1/car/findex/renewPIN",
    },
    city: {
      getCampaigns: "/v1/scar/city/GetAllCampaigns",
      getPopularCars: "/v1/scar/city/PopularVehicles",
      getCityAnalytics: "/v1/scar/city/CondensedAnalyticsData",
      getCityLocationInfo: "/v1/scar/city/PageLocationInfo",
      getRentalLocations: "/v1/scar/city/PopularRentalLocations",
      getPrivileges: "/v1/scar/city/Privileges",
      getCompanies: "/v1/scar/city/PopularCompanies",
      getLocations: "/v1/scar/city/PopularLocations",
      getWhyTurna: "/v1/scar/city/WhyTurna",
      getSss: "/v1/scar/city/FAQ",
    },
    district: {
      getCampaigns: "/v1/scar/district/GetAllCampaigns",
      getPopularCars: "/v1/scar/district/PopularVehicles",
      getDistrictAnalytics: "/v1/scar/district/CondensedAnalyticsData",
      getDistrictLocationInfo: "/v1/scar/district/PageLocationInfo",
      getRentalLocations: "/v1/scar/district/PopularRentalLocations",
      getPrivileges: "/v1/scar/district/Privileges",
      getCompanies: "/v1/scar/district/PopularCompanies",
      getLocations: "/v1/scar/district/PopularLocations",
      getWhyTurna: "/v1/scar/district/WhyTurna",
      getSss: "/v1/scar/district/FAQ",
    },
    airport: {
      getCampaigns: "/v1/scar/Airport/GetAllCampaigns",
      getPopularCars: "/v1/scar/Airport/PopularVehicles",
      getAirportAnalytics: "/v1/scar/Airport/CondensedAnalyticsData",
      getAirportLocationInfo: "/v1/scar/Airport/PageLocationInfo",
      getRentalLocations: "/v1/scar/Airport/PopularRentalLocations",
      getPrivileges: "/v1/scar/Airport/Privileges",
      getCompanies: "/v1/scar/Airport/PopularCompanies",
      getLocations: "/v1/scar/Airport/PopularLocations",
      getWhyTurna: "/v1/scar/Airport/WhyTurna",
      getSss: "/v1/scar/Airport/FAQ",
    },
    company: {
      getAllCompanies: "/v1/scar/company/GetAllCompanies",
      getCompanyInfo: "/v1/scar/company/PageCompanyInfo",
      getPopularCars: "/v1/scar/company/PopularVehicles",
      getPrivileges: "/v1/scar/company/Privileges",
      getCampaigns: "/v1/scar/company/GetCompanyCampaigns",
      getRentalLocations: "/v1/scar/company/PopularRentalLocations",
      getNeedToKnow: "/v1/scar/company/NeedToKnows",
      getLocations: "/v1/scar/company/PopularLocations",
      getCompanies: "/v1/scar/company/PopularCompanies",
      getSEOText: "/v1/scar/company/About",
      getSss: "/v1/scar/company/FAQ",
    },
  },
  canonicalLocation: {
    location: {
      getLocations: "/api/v1/canonical-location/location/getlocations",
    },
  },
  account: {
    pointDetails: {
      getPointDetails: "/v2/saka/profile/getpointsummary",
      getPointHistory: "/v2/saka/profile/getpointhistory",
    },
    invitations: {
      getInvitations: "/v2/saka/profile/getinvitedusers",
      inviteFriend: "/v1/accounts/user/SendInvitation",
      getInvitationLink: "/v1/accounts/user/GetInvitationLink",
      getInvitorReference: "/v1/accounts/user/UserReference",
    },
    profile: {
      getUserInfo: "/v2/saka/profile/getuserprofile",
      updateUserInfo: "/v2/saka/profile/updateuserprofile",
      communicationPreferences:
        "/v2/saka/profile/updatecommunicationpreferences",
      getCommunicationPermission: "/v2/saka/profile/GetCommunicationPermission",
      cancelAccount: "/v2/saka/profile/deactivateAccount",
      changePassword: "/v2/saka/profile/changepassword",
      sendSmsOTP: "/v2/saka/profile/sendsmsotp",
      verifySMSOTP: "/v2/saka/profile/verifysmsotp",

      sendEmailOTP: "/v2/saka/emailverification/sendotp",
      verifyEmailOTP: "/v2/saka/emailverification/verifyotp",
      verifyEmailToken: "/v2/saka/emailverification/confirmemail",

      sendForgotPasswordOTP: "/v2/saka/forgotpassword/sendotp",
      verifyForgotPasswordOTP: "/v2/saka/forgotpassword/verifyotp",
      resetPassword: "/v2/saka/forgotpassword/resetpassword",
    },
    passengers: {
      getPassengers:
        "/v2/saka/UserRegisteredPassengers/GetUserRegisteredPassengers",
      updatePassenger:
        "/api/v2/saka/UserRegisteredPassengers/UpdateUserRegisteredPassenger",
      createPassenger:
        "/api/v2/saka/UserRegisteredPassengers/InsertRegisteredUserPassenger",
    },
    priceAlarm: {
      getPriceAlarms: "/v2/saka/pricealarm/getpricealarms",
      createPriceAlarm: "/v2/saka/pricealarm/createpricealarm",
      deletePriceAlarm: "/v2/saka/pricealarm/deletepricealarm",
    },
    savedCards: {
      getSavedCards: "/v2/saka/creditcard/getSavedCards",
      sendSaveCardOTP: "/v2/saka/creditcard/sendSaveCardOtp",
      saveCard: "/v2/saka/creditcard/saveCreditCard",
      updateSavedCard: "/v2/saka/creditcard/updateSavedCard",
      deleteSavedCard: "/v2/saka/creditcard/deleteSavedCard",
    },
    invoiceInformation: {
      getUserAdress: "/v1/accounts/user/UserDetail",
      updateUserAdress: "/v1/accounts/user/UpdateUserAddress",
    },
    favorites: {
      getAll: "/v1/meta/favorite/GetAll",
      remove: "/v1/meta/favorite/Remove",
    },
  },
  aboutUs: {
    getAboutUs: "/v2/saka/aboutus/getAboutUs",
  },
  publicHolidays: {
    getPublicHolidays: "/v1/meta/publicholiday/GetPublicHolidays",
    getPublicHolidayBySlug: "/v1/meta/publicholiday/GetPublicHolidayBySlug",
    getPublicHolidayById: "/v1/meta/publicholiday/GetPublicHolidayById",
    getPublicHolidaysByDateRange:
      "/v1/meta/publicholiday/GetPublicHolidaysByDateRange",
    getCategories: "/v1/meta/publicholiday/GetCategories",
    getCategoriesHierarchy: "/v1/meta/publicholiday/GetCategoriesHierarchy",
    getRootCategories: "/v1/meta/publicholiday/GetRootCategories",
    getCategoryChildren: "/v1/meta/publicholiday/GetCategoryChildren",
    getCategoryById: "/v1/meta/publicholiday/GetCategoryById",
  },
  campaign: {
    getCampaigns: "/v2/saka/campaigns/activeCampaigns",
    getCampaignDetails: "/v2/saka/campaigns/getCampaignContent",
  },
  faq: {
    getFAQRootCategories: "/v1/meta/faq/GetRootCategories",
    getFAQCategoryBySlug: "/v1/meta/faq/GetCategoryHierarchyBySlug",
    getFAQBySlug: "/v1/meta/faq/GetFaqBySlug",
    searchFaq: "/v1/meta/faq/AutocompleteFaqs",
    getFAQCategoryOrQuestion: "/v1/meta/faq/GetBySlug",
  },
  pointConvert: {
    pointInquiryNewCard: "/v1/accounts/user/CreditCardPointsV2",
    pointInquirySavedCard: "/v1/accounts/user/StoredCardPointsV2",

    pointConvertWithNewCard: "/v1/accounts/user/CCPointInit3d",
    pointConvertWithSavedCard:
      "/v1/accounts/user/convertStoredCardPointsThreeD",

    completePointConvertPaymentNewCard:
      "/v1/accounts/user/insertLPFromPointConvertPayment",
    completePointConvertPaymentSavedCard:
      "/v1/accounts/user/getStoredCardPointConversionResult",

    periodConversion: "/v1/accounts/user/startPeriodicPointConversion",

    sendSaveCardOTP: "/v2/saka/creditcard/sendSaveCardOtp",
    verifySaveCardOTP:
      "/v2/saka/creditcard/SaveCreditCardFromSessionForPointConversion",
  },
};

export default API_URLS;
